import { useEffect, useRef, useState } from "react";
import NiceModal from "@ebay/nice-modal-react";
import ModalBase from "modals/base/ModalBase";
import OverlayMenuBase from "modals/base/OverlayMenuBase";
import { requester } from "App";
import VerticalFlex from "layouts/flex/VerticalFlex";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import FlexChild from "layouts/flex/FlexChild";
import style from "./SideMenu.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { menus } from "data/menus";
import MenuGroup from "routes/MenuGroup";

const SideMenu = NiceModal.create(
    (props, ref) => {
        const modal = useRef();
        const [withHeader, withFooter] = [true, false];
        const [width, height] = ["min(80%, 500px)", "200vh"];
        const withCloseButton = true;
        const clickOutsideToClose = true;

        return (
            <OverlayMenuBase ref={modal} width={width} height={height} withHeader={withHeader} withCloseButton={withCloseButton} clickOutsideToClose={clickOutsideToClose} >
                <div className={style.menu}>
                    <div className={style.menuList}>
                        {
                            menus.map((menu) => {
                                if (menu.type === "group") {
                                    return <MenuGroup key={menu.id} data={menu} />;
                                } else if (menu.type === "item") {

                                }
                            })
                        }
                    </div>
                </div>
            </OverlayMenuBase>
        );
    }
);

export default SideMenu;
